import React from 'react';
import {Container} from 'flux/utils';
import SuggestionBox from './suggestion_box';
import {productRenderer} from "../../helper/suggestion_renderer/product";
import SearchStore from '../../stores/search_store';
import SearchActions from '../../actions/search_actions';

class SuggestionBoxContainer extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    /**
     * @returns {[*]}
     */
    static getStores() {
        return [SearchStore];
    }

    /**
     * @returns {{suggestionBox: ({stations, activeStation, qty, tyreId, availableQuantities, setPrice, buy4pay3,
     *     off15Perc, freefitting, price, currencyHTML, availability, ean}|*|CodePathState|TState)}}
     */
    static calculateState() {
        return {
            suggestionBox: SearchStore.getState(),
        };
    }

    componentWillMount() {
        document.addEventListener('click', this.handleClick.bind(this), false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick.bind(this), false);
    }

    /**
     * @returns {SuggestionBoxContainer}
     */
    handleClick(event) {
        if(!ReactDOM.findDOMNode(this).contains(event.target)) {
            SearchActions.hideSuggestions();
        }

        return this;
    }

    /**
     * @param {SyntheticEvent} event
     */
    onChange(event) {
        fetchSuggestions(event.target.value);
    }

    /**
     * @returns {{products: productRenderer}}
     */
    getSuggestionRenderers() {
        return {
            'products': productRenderer
        };
    }

    render() {
        const {suggestions, showSuggestions} = this.state.suggestionBox;

        return (
            <SuggestionBox
                label={'SEARCH FOR'}
                onChange={this.onChange}
                suggestions={suggestions}
                suggestionRenderers={this.getSuggestionRenderers()}
                showSuggestions={showSuggestions}
                name={'q'}
                id={'suggestion-box'}
                placeholder={'e.g. Bridgestone 255/60R16'}
            />
        );
    }
}

export default Container.create(SuggestionBoxContainer);

/**
 * @param {string} term
 * @returns {Promise}
 */
async function fetchSuggestions(term) {
    return await SearchActions.fetchSuggestionsFor(term);
}